// extracted by mini-css-extract-plugin
export default {"cls1":"VeloActionBar-MenuDivider_cls1__Mvb3y","cls2":"VeloActionBar-MenuDivider_cls2__942SL VeloActionBar-MenuDivider_cls1__Mvb3y"};